import './ServiceItem.css';

import React from 'react'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import { memo } from 'react';
import { iconsMap } from '../../utils';
import UserItem from '../common/UserItem';
import { useAuth } from '../../contexts/auth';
import { BdaService } from '../../models/BdaService';
import { Tooltip } from 'antd';
// import { formatDate } from '../utils';

type Props = {
  service: BdaService;
  actions?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  onServiceEdit?: React.MouseEventHandler<HTMLButtonElement>;
  onServiceDelete?: React.MouseEventHandler<HTMLButtonElement>;
}

function ServiceItem({ service, actions, onClick, onServiceEdit, onServiceDelete }: Props) {
  // const date = formatDate(service.createDateTime);
  const { loggedUser } = useAuth();
  const mode = service.mode === 'BATCH' ? 'dark' : 'stream';
  const modeIcon = service.mode === 'BATCH' ? solid('cog') : solid('align-left');

  return (
    <Card className="service-item" onClick={onClick}>
      <Card.Header className={`service-item-header bg-${service.mode.toLowerCase()}`}>
        <Row className="gx-0 align-items-start justify-content-between">
          <Badge bg="none" className="service-version">{service.version}</Badge>
          <Badge className="shadow w-auto">{service.accessLevel}</Badge>
        </Row>
        <FontAwesomeIcon className="service-icon" icon={iconsMap.get(service.area!) || solid('chart-pie')} />

        <div className="header-content">
          <Tooltip title={service.name} mouseEnterDelay={0.3}>
            <h5 className="service-title text-white mb-2">{service.name}</h5>
          </Tooltip>
          <Badge bg="none" className={`service-mode shadow bg-${mode}`} pill={true}>
            <FontAwesomeIcon icon={modeIcon} />
            <span className="ms-2">{service.mode}</span>
          </Badge>
          <p className="service-description line-clamp-2 mt-2">{service.description}</p>
        </div>

        <Row className="gx-0 position-relative justify-content-center">
          {actions || (loggedUser?.userId === service.owner!.id && (
            <Col className="text-center" xs={9}>
              <button className="circle-button" onClick={onServiceEdit}>
                <FontAwesomeIcon size="sm" icon={solid('pen')} />
              </button>
              <button className="circle-button ms-3" onClick={onServiceDelete}>
                <FontAwesomeIcon size="sm" icon={solid('trash')} />
              </button>
            </Col>
          ))}
        </Row>
      </Card.Header>
      <Card.Body className="p-2">
        <div className="d-flex align-items-center">
          <Col className="overflow-hidden">
            <UserItem user={service.owner!} organization={service.organization!} />
          </Col>

          <div className="framework-image" style={{ backgroundImage: `url(${service.framework!.imageUrl})` }}></div>
        </div>
      </Card.Body>
    </Card>
  )
}

export default memo(ServiceItem);